import { render, staticRenderFns } from "./SolicitarRevision.vue?vue&type=template&id=453c701a&scoped=true&"
import script from "./SolicitarRevision.vue?vue&type=script&lang=js&"
export * from "./SolicitarRevision.vue?vue&type=script&lang=js&"
import style0 from "./SolicitarRevision.vue?vue&type=style&index=0&id=453c701a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "453c701a",
  null
  
)

export default component.exports